import React from 'react';
import MediaRouteHeaderTitle from '@/components/Navigation/Routes/MediaRouteHeaderTitle';

const MusicRouteNavigationOptions = {
  title: 'Music',
  headerTitle: () => (
    <MediaRouteHeaderTitle
      loggedInKey="navigation.music"
      loggedOutKey="navigation.createMusic"
      fallback="Music"
    />
  ),
  headerBackVisible: false,
};

export default MusicRouteNavigationOptions;
